export default "__VITE_ASSET__084cdbdc__"